import Layout from "../../../../components/layout/Layout";
import HiddenLoader from "../../../../components/loader/HiddenLoader/HiddenLoader";
import { useFrontofficeContext } from "../../../../context/FrontofficeContext";

function VisitorTypePageView({ flowPlayer, visitorType }) {
  const { terminal } = useFrontofficeContext();
  const layout = visitorType?.layout || terminal?.layout;
  return (
    <Layout
      layoutData={layout}
      content={
        <HiddenLoader groups="flow_player_first_step" iconSize="lg">
          {flowPlayer.renderStep()}
        </HiddenLoader>
      }
    />
  );
}

export default VisitorTypePageView;
